import { render, staticRenderFns } from "./storesWithdrawal.vue?vue&type=template&id=23d49d81"
import script from "./storesWithdrawal.vue?vue&type=script&lang=js"
export * from "./storesWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports